module.exports = __webpack_public_path__ + "img/logo.44953a58.jpg";